import { Activity } from '../activity/activity.model';
import { Organization } from '../organization/organization.model';
import { PaymentHistory } from '../payment/payment-history.model';
import {
  AdminRole,
  createRoleInformationFormGroup,
  RoleInformation,
  StaffRole,
  UserRole,
} from './lib/staff.interfaces';
import { ApiResource } from '../api-resource';
import { EmergencyContact } from '../_lib/emergency';
import {
  DateField,
  Field,
  StringField,
} from '../../util/components/resource/resource-fields/resource-fields';
import { Endpoint } from '../api.decorators';
import {
  IdentityCarrier,
  IdentityPayload,
} from '../../util/identity/lib/identity.interfaces';
import { StaffSkill } from '../skillz/staff-skillz/staff-skillz.model';
import { Address } from '../_lib/address';
import { Person } from '../_lib/person';

@Endpoint('staff', 'Staff')
export class Staff
  extends ApiResource<Staff>
  implements Person, Address, IdentityCarrier
{
  @StringField({ label: $localize`First name` })
  firstName!: string;

  @StringField({ label: $localize`Last name` })
  lastName!: string;

  get fullName(): string {
    return `${this.firstName} ${this.lastName}`;
  }

  @StringField({ label: $localize`Email` })
  email!: string;

  @Field({ readonly: true, label: $localize`Avatar URL`, type: () => Blob })
  avatar!: string;

  @StringField({ label: $localize`Phone number` })
  phoneNumber!: string;

  @DateField({ label: $localize`Date of birth` })
  dateOfBirth!: Date;

  @Field({ includeFilter: false, type: () => Object })
  identities!: IdentityPayload[];

  @StringField({ label: $localize`Bank account` })
  bankAccountNumber!: string;

  @StringField({ label: $localize`Address` })
  address!: string;

  @StringField({ label: $localize`City` })
  city!: string;

  @StringField({ label: $localize`Postal code` })
  zipCode!: string;

  @StringField({ label: $localize`Country` })
  country!: string;

  role!: UserRole;

  @Field({
    default: () => [],
    label: $localize`Staff roles`,
    type: () => StaffRole,
  })
  staffRoles!: StaffRole[];

  @Field({
    default: () => [],
    label: $localize`Admin roles`,
    type: () => AdminRole,
  })
  adminRoles!: AdminRole[];

  @StringField({ default: () => '', label: $localize`Direct message ID` })
  directMessageId!: string;

  @Field({
    formControlFactory: createRoleInformationFormGroup,
    includeFilter: false,
    type: () => Object,
  })
  roleInformation?: RoleInformation;

  @Field({
    default: () => [],
    readonly: true,
    includeFilter: false,
    type: () => Object,
  })
  emergencyInformation?: EmergencyContact[];

  @Field({
    type: () => Organization,
    readonly: true,
    label: $localize`Organizations`,
  })
  organizations!: Organization[];

  @Field({ type: () => PaymentHistory, readonly: true, includeFilter: false })
  paymentHistory?: PaymentHistory;

  @Field({ type: () => Document, readonly: true, includeFilter: false })
  documents?: Document[];

  @Field({ type: () => Activity, readonly: true, includeFilter: false })
  activities?: Activity[];

  @Field({ type: () => StaffSkill, readonly: true, label: $localize`Skills` })
  skills?: StaffSkill[];

  @Field({ label: $localize`Comment` })
  comment!: string;

  @Field({ default: () => true, label: $localize`Can apply` })
  canApply!: boolean;

  override toLabel(): string {
    return this.fullName;
  }
}
